import React from "react";
import "./review.scss";
import FormTitle from "../components/formTitle/FormTitle";
import axios from "axios";
import Config from "../common/Config";
import Review from "./Review";
import SecondaryButton from "../components/button/SecondaryButton";
import Button from "../components/button/Button";

class XtremityReview extends Review {
  constructor(props) {
    super(props);

    this.state = {
      uOM: null,
      mPTToFloor: null,
      calfToFloor: null,
      calfCirc: null,
      ankleCirc: null,
      iTToFloor: null,
      thighToFloor: null,
      kCToFloor: null,
      thighCirc: null,
      kCCirc: null,
      notes: null,
      socketFinish: [],
      otherPRS: [],
      socketOption: [],
      insertMaterial: [],
      mountingPlate: [],
      socketMaterial: [],
      suspension: [],
      trimline: [],
      cart: [],
      cadFileName: null,
    };
  }

  componentDidMount() {
    super.componentDidMount();
    this.loadData();
  }

  async loadData() {
    try {
      super.loadData();
      let fieldInputConfig = {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("token"))?.access_token,
        },
        params: {
          fieldNames: [
            "uOM",
            "mPTToFloor",
            "calfToFloor",
            "calfCirc",
            "ankleCirc",
            "socketFinish",
            "otherPRS",
            "socketOption",
            "insertMaterial",
            "mountingPlate",
            "iTToFloor",
            "thighToFloor",
            "kCToFloor",
            "thighCirc",
            "kCCirc",
            "socketMaterial",
            "xtremitySuspension",
            "trimline",
          ],
        },
      };

      if (this.props.uniqueId != null) {
        fieldInputConfig.headers.UniqueId = this.props.uniqueId;
      }

      let fieldInputs = (
        await axios.get(
          Config.baseApiUrl + "fieldInputs/" + this.props.formTypeId,
          fieldInputConfig
        )
      ).data;

      const cadFile = (
        await axios.get(
          Config.baseApiUrl + "cadFiles/" + this.props.formTypeId,
          fieldInputConfig
        )
      ).data;

      this.setState({
        uOM: fieldInputs.find((fi) => fi.fieldName === "uOM")?.fieldOptionName,
        mPTToFloor:
          fieldInputs.find((fi) => fi.fieldName === "mPTToFloor")?.numericData ??
          0,
        calfToFloor:
          fieldInputs.find((fi) => fi.fieldName === "calfToFloor")
            .numericData ?? 0,
        calfCirc:
          fieldInputs.find((fi) => fi.fieldName === "calfCirc")?.numericData ??
          0,
        ankleCirc:
          fieldInputs.find((fi) => fi.fieldName === "ankleCirc")?.numericData ??
          0,
        iTToFloor:
          fieldInputs.find((fi) => fi.fieldName === "iTToFloor")?.numericData ??
          0,
        thighToFloor:
          fieldInputs.find((fi) => fi.fieldName === "thighToFloor")?.numericData ?? 
          0,
        kCToFloor:
          fieldInputs.find((fi) => fi.fieldName === "kCToFloor")?.numericData ??
          0,
        thighCirc:
          fieldInputs.find((fi) => fi.fieldName === "thighCirc")?.numericData ??
          0,
        kCCirc:
          fieldInputs.find((fi) => fi.fieldName === "kCCirc")?.numericData ?? 0,
        socketFinish: fieldInputs.filter(
          (fi) => fi.fieldName === "socketFinish"
        ),
        otherPRS: fieldInputs.filter((fi) => fi.fieldName === "otherPRS"),
        socketOption: fieldInputs.filter(
          (fi) => fi.fieldName === "socketOption"
        ),
        insertMaterial: fieldInputs.filter(
          (fi) => fi.fieldName === "insertMaterial"
        ),
        suspension: fieldInputs.filter(
          (fi) => fi.fieldName === "xtremitySuspension"
        ),
        trimline: fieldInputs.filter(
          (fi) => fi.fieldName === "trimline"
        ),
        socketMaterial: fieldInputs.filter(
          (fi) => fi.fieldName === "socketMaterial"
        ),
        cadFileName: cadFile !== null ? cadFile.cadFileName : null,
      });
      await this.loadCart(fieldInputConfig);
    } catch (error) {
      //   this.props.handleError(new LoadFailureResult());
    }
    this.setState({ isLoaded: true });
  }

  async saveData() {
    let config = {};
    config.headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("token")).access_token,
    };

    return axios.post(
      Config.baseApiUrl + "orders/" + this.props.formTypeId,
      null,
      config
    );
  }

  async loadCart(config) {
    let orderCart = (await axios.get(
      Config.baseApiUrl + "cart/" + this.props.formTypeId,
      config
    )).data;

    this.setState({ cart: orderCart });
  }

  cartTotal(cart) {
    let total = 0;
    cart.forEach((item) => {
      if (item.quantity > 0 && item.price > 0) {
        total += item.price * item.quantity;
      }
    });

    return total;
  }

  formatPrice(price) {
    return Number(price).toFixed(2);
  }

  render() {
    if (!this.state.isLoaded) return this.makeLoadingText();
    return (
      <>
        <div
          className={`reviewWrapper ${
            this.props.isBilateral ? "bilateralWrapper" : ""
          }`}
        >
          {!this.props.isBilateral && (
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <FormTitle
                title="Order Review"
                description=""
              />
            </div>
          )}

          <div className="reviews">
            <div>
              {!this.props.showOrderSummary && (
                <div className="summaryName">
                  <h4>Order Summary</h4>
                  {this.props.isBilateral && (
                    <div className="bileralName">
                      <h2>{this.props.bilateralName}</h2>
                    </div>
                  )}
                  {!this.props.isBilateral && <h2>{this.props.formName}</h2>}
                </div>
              )}
              <div className="summaaryHeader">
                <h2>
                  {this.props.name}
                  {this.props.isBilateral &&
                    " (Order " + this.props.orderNumber + ")"}
                </h2>
                <div className="poDate">
                  <div className="po">
                    <span>PO:</span>
                    <p>{this.state.poNumber}</p>
                  </div>
                  <div className="po">
                    <span>SSD:</span>
                    <p>{this.formatShipDate(this.state.estimatedShipDate)}</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="information">
              <h3>Patient Information</h3>
              <div className="patientInfo">
                <div className="infoBorder">
                  <div className="patientSubInfo">
                    <span>Patient ID:</span>
                    <p>{this.state.patientId}</p>
                  </div>
                  <div className="patientSubInfo">
                    <span>Weight:</span>
                    <p>{this.state.weight}</p>
                  </div>
                  <div className="patientSubInfo">
                    <span>Height:</span>
                    <p>{this.state.height}</p>
                  </div>
        
                  <div className="patientSubInfo">
                    <span>K Level</span>
                    <p>{this.state.kLevel}</p>
                  </div>
                </div>

                <div className="info">
                  <div className="patientSubInfo">
                    <span>Amputation Level</span>
                    <p>{this.state.amputationLevel}</p>
                  </div>
                  <div className="patientSubInfo">
                    <span>Amputation Side</span>
                    <p>{this.state.footDirection}</p>
                  </div>
                  <div className="patientSubInfo">
                    <span>PO#</span>
                    <p>{this.state.poNumber}</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="information">
              <div className="subDetail">
                <h3>Product Information</h3>

                <div className="detailWrapper">
                  <div>

                    <div className="detail">
                      <h4>Socket Material</h4>
                      <div className="detailContentWrapper">
                        <div className="content">
                          <span>Socket Material:</span>
                          {this.makeFieldOutput(this.state.socketMaterial)}
                        </div>
                        {this.state.cadFileName !== null ? (
                          <div className="content">
                            <span>Filename:</span>
                            <p>{this.state.cadFileName}</p>
                          </div>
                        ) : <></>}
                      </div>
                    </div>

                    <div className="detail">
                      <h4>Suspension</h4>
                      <div className="detailContentWrapper">
                        <div className="content">
                          <span>Suspension:</span>
                          {this.makeFieldOutput(this.state.suspension)}
                        </div>
                      </div>
                    </div>

                    <div className="detail">
                      <h4>Trim Line Option</h4>
                      <div className="detailContentWrapper">
                        <div className="content">
                          <span>Trimline:</span>
                          {this.makeFieldOutput(this.state.trimline)}
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>

              <div className="msgInfo ">
                <h3>Items sent in with socket</h3>
                <p>{this.state.itemsSentIn}</p>
              </div>

              <div className="msgInfo ">
                <h3>Other Notes</h3>
                <p>{this.state.notes}</p>
              </div>
            </div>

            {!this.props.showOrderInfo && (
              <div className="information">
                <h3>Patient Measurement</h3>
                <div className="patientInfo">
                  <div className="customerInfo">
                    <div className="patientSubInfo">
                      <span>Bill to account:</span>
                      <p>{this.state.accountNumber}</p>
                    </div>
                    <div className="patientSubInfo">
                      <span>Clinic:</span>
                      <p>{this.state.clinicName}</p>
                    </div>
                    <div className="patientSubInfo">
                      <span>Clinician Name:</span>
                      <p>{this.state.prosthetistName}</p>
                    </div>
                    <div className="patientSubInfo">
                      <span>Email Address</span>
                      <p>{this.state.email}</p>
                    </div>
                    <div className="patientSubInfo">
                      <span>Phone</span>
                      <p>{this.state.phone}</p>
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div className="information">
              <h3>Shipping Information</h3>
              <div className="patientInfo">
                <div className="">
                  <div className="borderBotom shippingInfo">
                    <div className="patientSubInfo">
                      <span>Shipping Address Line 1:</span>
                      <p>{this.state.shippingAddress1}</p>
                    </div>
                    <div className="patientSubInfo">
                      <span>Shipping Address Line 2:</span>
                      <p>{this.state.shippingAddress2}</p>
                    </div>
                  </div>

                  <div className="shipping info">
                    <div className="patientSubInfo">
                      <span>State:</span>
                      <p>{this.state.stateName}</p>
                      <span>City:</span>
                      <p>{this.state.city}</p>
                      <span>Shipping Method:</span>
                      <p>{this.state.shippingMethodName}</p>
                    </div>
                    <div className="patientSubInfo">
                      <span>Zip Code:</span>
                      <p>{this.state.zip}</p>
                      <span>Carrier:</span>
                      <p>{this.state.shippingCarrierName}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {this.state.cart.length > 0 ? (
              <div className="information">
                <div className="mb-3"><h3>Cart</h3></div>
                <div className="patientInfo">
                  <div className="patientSubInfo">
                    <table className="transparent-table table">
                      <thead>
                        <th><span><b>Name</b></span></th>
                        <th></th>
                        <th><span><b>Part Number</b></span></th>
                        <th><span><b>Quantity</b></span></th>
                        <th className="text-right"><span><b>Price</b></span></th>
                      </thead>
                      <tbody>
                        {this.state.cart.map(item => {
                          return (
                            <>
                              <tr key={item.partNumber}>
                                <td lg="6" sm="1">
                                  <div className="content">
                                    <p style={{ "whiteSpace": "break-spaces" }}>{item.name}</p>
                                  </div>
                                </td>
                                <td></td>
                                <td>
                                  <p>{item.partNumber}</p>
                                </td>
                                <td>
                                  <p>{item.quantity}</p>
                                </td>
                                <td>
                                  <p className="text-right">${this.formatPrice(item.price)}</p>
                                </td>
                              </tr>
                              <br />
                            </>)
                        })}
                        <tr>
                          <td>
                            <div>
                              <span><b>Total</b></span>
                            </div>
                          </td>
                          <td colSpan={4}>
                            <p className="text-right">
                              ${this.formatPrice(this.cartTotal(this.state.cart))}
                            </p>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            ) : <></>}

          </div>
        </div>

        {this.getNavButtons(this.props.uniqueId)}
      </>
    );
  }

  getNavButtons(uniqueId) {
    if (uniqueId != null) {
      return;
    }
  
    return (
      <div className="handelButtons">
            <div className="stepBtn">
              <SecondaryButton
                text="Back"
                onClick={() =>
                  this.props.handleBack(this?.props?.currentIndex - 1)
                }
                disabled={
                  this.props.activeOuterStep == 0 && this.props.innerStep == 0
                }
              />
              <Button
                text="Submit"
                disabled={this.state.isLoading}
                onClick={() => {
                  this.saveData();
                  this.props.handleNext(this?.props?.currentIndex);
                }}
              />
            </div>
          </div>
    );
  }
  
}


export default XtremityReview;
